import { render, staticRenderFns } from "./bannerConfig.vue?vue&type=template&id=bee8a76e&scoped=true"
import script from "./bannerConfig.vue?vue&type=script&lang=js"
export * from "./bannerConfig.vue?vue&type=script&lang=js"
import style0 from "./bannerConfig.vue?vue&type=style&index=0&id=bee8a76e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee8a76e",
  null
  
)

export default component.exports